import tradingPlatformsContent from "./content/trading-platforms.json";

export const tradingPlatformsMock = {
  name: "trading-platforms",
  layoutType: 1,
  areasList: [
    {
      id: "trading-platforms-1",
      name: "trading-platforms-content",
      componentName: "Comp:TradingPlatformsPage",
      content: JSON.stringify(tradingPlatformsContent),
    },
  ],
};
